// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MyfR","content":"styles_content__1_BSX"};